var map = {
	"./App_Store_Badge": 3,
	"./App_Store_Badge.svg": 3,
	"./Icon_Facebook": 4,
	"./Icon_Facebook.svg": 4,
	"./Icon_Instagram": 5,
	"./Icon_Instagram.svg": 5,
	"./Icon_Twitter": 6,
	"./Icon_Twitter.svg": 6,
	"./Logo_Tavour_White/Logo_Tavour_White": 7,
	"./Logo_Tavour_White/Logo_Tavour_White.png": 7,
	"./Logo_Tavour_White/Logo_Tavour_White@2x": 8,
	"./Logo_Tavour_White/Logo_Tavour_White@2x.png": 8,
	"./Logo_Tavour_White/Logo_Tavour_White@3x": 9,
	"./Logo_Tavour_White/Logo_Tavour_White@3x.png": 9,
	"./abv_icon": 10,
	"./abv_icon.svg": 10,
	"./can_icon": 11,
	"./can_icon.svg": 11,
	"./chevron_right": 12,
	"./chevron_right.svg": 12,
	"./default_beer_image": 13,
	"./default_beer_image.svg": 13,
	"./favicon": 14,
	"./favicon.png": 14,
	"./footer_background_image": 15,
	"./footer_background_image.jpeg": 15,
	"./google-play-badge": 16,
	"./google-play-badge.png": 16,
	"./heart_empty": 17,
	"./heart_empty.svg": 17,
	"./org_footer_background_image": 18,
	"./org_footer_background_image.jpeg": 18,
	"./star_icon_0": 19,
	"./star_icon_0.svg": 19,
	"./star_icon_100": 20,
	"./star_icon_100.svg": 20,
	"./star_icon_50": 21,
	"./star_icon_50.svg": 21,
	"./tavour_icon_100": 22,
	"./tavour_icon_100.png": 22,
	"./tavour_logo_small": 23,
	"./tavour_logo_small.png": 23,
	"./tavour_logo_with_name": 24,
	"./tavour_logo_with_name.png": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;